import { gql } from "@apollo/client";
import client from "../apolloClient";
import {
  TermsAndConditionsFilters,
  TermsAndConditionsResult,
  TermsAndConditionsRequest,
  TermsAndConditions,
} from "../../schemas/termsAndConditionsSchema";

const GET_TERMS_AND_CONDITIONS = gql`
  query GetTermsAndConditions($page: Int, $pageSize: Int) {
    termsAndConditions(page: $page, pageSize: $pageSize) {
      termsAndConditions {
        id
        tenantId
        fileName
        fileUrl
        version
        isActive
        createdAt
        updatedAt
        createdBy

      }
      page
      pageSize
      total
      totalPages
      hasNextPage
      hasPrevPage
    }
  }
`;

const GET_ACTIVE_TERMS_AND_CONDITIONS = gql`
  query GetActiveTermsAndConditions {
    activeTermsAndConditions {
      id
      tenantId
      fileName
      fileUrl
      version
      isActive
      createdAt
      updatedAt
      createdBy
    }
  }
`;

const UPLOAD_TERMS_AND_CONDITIONS = gql`
  mutation UploadTermsAndConditions($file: Upload!) {
    uploadTermsAndConditions(file: $file) {
      id
      tenantId
      fileName
      fileUrl
      version
      isActive
      createdAt
      updatedAt
      createdBy
    }
  }
`;

export const termsAndConditionsService = {
  getAll: async (
    filters: TermsAndConditionsFilters = {}
  ): Promise<TermsAndConditionsResult> => {
    const { data } = await client.query({
      query: GET_TERMS_AND_CONDITIONS,
      variables: filters,
      fetchPolicy: "network-only",
    });
    return data.termsAndConditions;
  },

  getActive: async (): Promise<TermsAndConditions | null> => {
    const { data } = await client.query({
      query: GET_ACTIVE_TERMS_AND_CONDITIONS,
      fetchPolicy: "network-only",
    });
    return data.activeTermsAndConditions;
  },

  upload: async (
    input: TermsAndConditionsRequest
  ): Promise<TermsAndConditions> => {
    const { data } = await client.mutate({
      mutation: UPLOAD_TERMS_AND_CONDITIONS,
      variables: {
        file: input.file,
      },
      context: {
        headers: {
          "Apollo-Require-Preflight": "true",
        },
      },
    });
    return data.uploadTermsAndConditions;
  },
};
